export enum TabStatus {
  Error = 'error',
  Loaded = 'loaded',
  Loading = 'loading',
}

export interface Props {
  id: string
  userId: string
  navigateTo: (path: string, state?: any, search?: string) => void
}

export interface NetworkUser {
  firstName: string
  imageId: string
  lastName: string
  role: string
  userId: string
}
